/**
 * Console accent registry — one accent color per console section, used
 * consistently across hero bands, metric tiles, icon badges and status
 * indicators. Dark-mode readiness: every new colored surface must reference
 * these tokens instead of ad-hoc hexes.
 */
export const SECTION_ACCENTS = {
  operations: '#00608d', // queues, cases, approvals, dashboard
  engagement: '#3f8e50', // customers, handover, proactive, notifications
  platform: '#b68a35', // services, builder, agents, integrations
  money: '#b2550a', // payments
  assurance: '#0173ab', // audit, admin, housing governance
  executive: '#b68a35', // executive dashboard command canvas
  night: '#3e4046',
} as const;

export type SectionAccent = keyof typeof SECTION_ACCENTS;

/** Per-agent accent (kept in sync with AgentDetail's ACCENT map). */
export const AGENT_ACCENTS: Record<string, string> = {
  gold: '#7c5e24',
  oasis: '#00608d',
  night: '#3e4046',
  sky: '#0173ab',
  sand: '#b2550a',
  rose: '#b52520',
};
